import Vue from 'vue'
import {
  Autocomplete,
  Button,
  Checkbox,
  Collapse,
  Datepicker,
  Datetimepicker,
  Dropdown,
  Field,
  Icon,
  Input,
  Modal,
  Navbar,
  Pagination,
  Radio,
  Select,
  Snackbar,
  Timepicker,
  Upload,
  Dialog,
  Loading
} from 'buefy'

Vue.use(Autocomplete)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Collapse)
Vue.use(Datepicker)
Vue.use(Datetimepicker)
Vue.use(Dropdown)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Navbar)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(Select)
Vue.use(Snackbar)
Vue.use(Timepicker)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Loading)
